import React, { ReactNode } from 'react';

import { Avatar as AntDAvatar } from 'antd';
import classNames from 'classnames';
import styled from 'styled-components';

import { getUsernameInitials } from '../../components/View/share/utils';
import { ACTOR_TYPE } from '../../constants';

const StyledAvatar = styled(AntDAvatar)`
  color: var(--positive-green);
  background-color: var(--positive-green-light);
  border: 1px solid var(--positive-green);

  &.competitor {
    color: var(--neutral-purple);
    background-color: var(--neutral-purple-light);
    border: 1px solid var(--neutral-purple);
  }
  &.company {
    background-color: var(--positive-green);
  }
  &.user {
    color: var(--dark-blue);
    border: 1px solid var(--dark-blue);
    background-color: var(--light-blue);
  }
  span {
    font-size: 10px;
    line-height: 10px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  className?: string;
  name?: string;
  type: string;
  icon?: ReactNode;
  size?: number;
  src?: string;
  color?: string;
}

const Avatar = ({ className, name, type, icon, size = 30, src, color }: Props) => {
  const customColorStyle =
    color && !src
      ? {
          color,
          borderColor: `${color}AA`,
          backgroundColor: `${color}33`,
        }
      : undefined;

  return (
    <Container className={className}>
      <StyledAvatar
        style={customColorStyle}
        className={classNames({
          competitor: type === ACTOR_TYPE.COMPETITOR,
          company: type === ACTOR_TYPE.COMPANY,
          user: type === ACTOR_TYPE.USER,
        })}
        icon={icon}
        size={size}
        src={src}
      >
        {name ? (type === ACTOR_TYPE.USER ? getUsernameInitials(name) : name[0]) : 'n/a'}
      </StyledAvatar>
    </Container>
  );
};

export default Avatar;
